import { ContentSection as ContentSectionType } from '@/lib/gcc-content'
import { FadeIn, SlideUp } from '@/components/animations'

interface ContentSectionProps {
  section: ContentSectionType
  className?: string
}

const ContentSection = ({ section, className = '' }: ContentSectionProps) => {
  return (
    <section
      data-testid={section.id}
      className={`py-24 px-4 sm:px-6 lg:px-8 ${className}`}
    >
      <div className="max-w-4xl mx-auto text-center">
        <FadeIn>
          <h2 className="text-3xl font-light text-slate-900 mb-8 lg:text-4xl tracking-tight">
            {section.title}
          </h2>
        </FadeIn>

        {section.subtitle && (
          <FadeIn delay={0.2}>
            <p className="text-xl text-slate-600 mb-12 leading-relaxed font-light">
              {section.subtitle}
            </p>
          </FadeIn>
        )}

        <SlideUp delay={0.3} className="text-lg text-slate-700 leading-relaxed space-y-6">
          <p className="font-light">{section.content}</p>

          {section.items && (
            <div className="mt-12 max-w-3xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                {section.items.map((item, index) => (
                  <SlideUp
                    key={index}
                    delay={0.5 + index * 0.1}
                    distance={20}
                    duration={0.5}
                  >
                    <div className="flex items-start text-left bg-white/50 rounded-lg p-6 backdrop-blur-sm">
                      <div className="flex-shrink-0 w-2 h-2 bg-slate-400 rounded-full mt-2.5 mr-4" />
                      <span className="text-slate-700 leading-relaxed">{item}</span>
                    </div>
                  </SlideUp>
                ))}
              </div>
            </div>
          )}
        </SlideUp>
      </div>
    </section>
  )
}

export default ContentSection